<template>
  <div class="container">
    <el-dialog title="手填快递单号" :visible.sync="dialogFormVisible">
      <el-form :model="form">
        <el-form-item label="快递单号" label-width="160">
          <el-input
            v-model="form.LogisticCode"
            autocomplete="off"
            clearable
          ></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="dialogFormVisible = false">取 消</el-button>
        <el-button type="primary" @click="onClickInputExpressConfirm"
          >确 定</el-button
        >
      </div>
    </el-dialog>

    <div
      v-show="false"
      style="
        position: fixed;
        left: calc(50% - 200px);
        top: 50px;
        background-color: rgb(65, 65, 65);
        padding: 30px 20px;
      "
    >
      <iframe
        ref="pringContent"
        id="print-content"
        width="400px"
        height="600px"
        frameborder="0"
      ></iframe>
    </div>

    <div class="header">
      请在扫码枪使用期间，不要使用电脑；取消操作请到后台订单列表
    </div>
    <div class="flex-center express-list">
      <div class="header" style="border: none; background: none">
        当前已配置快递
      </div>
      <div class="flex-center">
        <div class="item" v-for="item in expressList" :key="item.id">
          <el-image
            style="
              width: 40px;
              height: 40px;
              border: 1px solid rgb(110, 110, 110);
            "
            :src="item.img"
            fit="fill"
          ></el-image>

          <div class="express-title">{{ item.cname }}</div>
        </div>
      </div>
    </div>

    <div style="margin-top: 30px; overflow: hidden; border-radius: 10px">
      <el-table :data="erpDataList" style="width: 100%" stripe border>
        <el-table-column label="类型" width="80">
          <template slot-scope="scope">
            {{ scope.row.type == 0 ? "出库单" : "发票" }}
          </template>
        </el-table-column>

        <el-table-column
          label="单号"
          prop="cSysBarCode"
          width="160"
        ></el-table-column>
        <el-table-column label="部门" width="80">
          <template slot-scope="scope">
            <el-tooltip
              effect="dark"
              :content="scope.row.info.cdepname"
              placement="top-start"
            >
              <div class="one-row-text">
                {{ scope.row.info.cdepname }}
              </div>
            </el-tooltip>
          </template>
        </el-table-column>
        <el-table-column label="业务员" width="80">
          <template slot-scope="scope">
            <el-tooltip
              effect="dark"
              :content="scope.row.info.cPsn_Name"
              placement="top-start"
            >
              <div class="one-row-text">
                {{ scope.row.info.cPsn_Name }}
              </div>
            </el-tooltip>
          </template>
        </el-table-column>
        <el-table-column label="客户" width="240">
          <template slot-scope="scope">
            <el-tooltip
              effect="dark"
              :content="scope.row.info.cCusName"
              placement="top-start"
            >
              <div class="one-row-text">
                {{ scope.row.info.cCusName }}
              </div>
            </el-tooltip>
          </template>
        </el-table-column>
        <el-table-column label="发货仓库" width="100">
          <template slot-scope="scope">
            <el-tooltip
              effect="dark"
              :content="scope.row.info.cWhName"
              placement="top-start"
            >
              <div class="one-row-text">
                {{ scope.row.info.cWhName }}
              </div>
            </el-tooltip>
          </template>
        </el-table-column>
        <el-table-column label="发货方式" width="80">
          <template slot-scope="scope">
            <el-tooltip
              effect="dark"
              :content="scope.row.info.cSCName"
              placement="top-start"
            >
              <div class="one-row-text">
                {{ scope.row.info.cSCName }}
              </div>
            </el-tooltip>
          </template>
        </el-table-column>
        <el-table-column label="地址" width="200">
          <template slot-scope="scope">
            <el-tooltip
              effect="dark"
              :content="
                scope.row.info.SHENGFEN +
                scope.row.info.CHENGSHI +
                scope.row.info.QUXIAN +
                scope.row.info.CADDRESS
              "
              placement="top-start"
            >
              <div class="one-row-text">
                {{
                  scope.row.info.SHENGFEN +
                  scope.row.info.CHENGSHI +
                  scope.row.info.QUXIAN +
                  scope.row.info.CADDRESS
                }}
              </div>
            </el-tooltip>
          </template>
        </el-table-column>
        <el-table-column label="收货人" width="80">
          <template slot-scope="scope">
            <el-tooltip
              effect="dark"
              :content="scope.row.info.cCusPerson"
              placement="top-start"
            >
              <div class="one-row-text">
                {{ scope.row.info.cCusPerson }}
              </div>
            </el-tooltip>
          </template>
        </el-table-column>
        <el-table-column label="收货人联系方式" width="140">
          <template slot-scope="scope">
            <el-tooltip
              effect="dark"
              :content="scope.row.info.cMobilePhone"
              placement="top-start"
            >
              <div class="one-row-text">
                {{ scope.row.info.cMobilePhone }}
              </div>
            </el-tooltip>
          </template>
        </el-table-column>
        <el-table-column label="操作">
          <template slot-scope="scope">
            <el-button
              style="margin: 5px 3px"
              v-if="
                scope.row.outgoing == 1 &&
                (scope.row.data.rehtml == '' || scope.row.data.rehtml == null)
              "
              type="info"
              size="small"
              @click="onClickInputExpressNo(scope.row, scope.$index)"
              >填写单号</el-button
            >
            <el-button
              style="margin: 5px 3px"
              v-if="
                scope.row.outgoing == 1 &&
                (scope.row.data.rehtml == '' || scope.row.data.rehtml == null)
              "
              type="warning"
              size="small"
              @click="onClickGetExpress(scope.row, scope.$index)"
              >生成快递单</el-button
            >
            <el-button
              v-if="
                scope.row.outgoing == 1 &&
                scope.row.data.rehtml != '' &&
                scope.row.data.rehtml != null
              "
              style="margin: 5px 3px"
              type="primary"
              size="small"
              @click="onClickSend(scope.row, scope.$index)"
              >发货</el-button
            >
            <!-- <el-button
              v-if="scope.row.outgoing == 2"
              style="margin: 5px 3px"
              type="danger"
              size="small"
              @click="onClickCancelSend"
              >取消发货</el-button
            > -->
            <el-button
              v-if="
                scope.row.data.rehtml != '' && scope.row.data.rehtml != null
              "
              style="margin: 5px 3px"
              type="success"
              size="small"
              @click="onClickPrint(scope.row.data)"
              >打印</el-button
            >
          </template>
        </el-table-column>
      </el-table>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapActions } from "vuex";

export default {
  name: "index",
  data() {
    return {
      admin_id: "",
      erpDataList: [],
      form: {
        index: 0, //数组中的下标
        cSysBarCode: "", //发货单编码
        id: "", //订单id
        LogisticCode: "", //快递单号
      },
      dialogFormVisible: false,
    };
  },
  computed: {
    ...mapGetters(["scanList", "expressList"]),
  },
  watch: {
    scanList(val) {
      let isReceipt = this.$tool.isReceipt(val[val.length - 1]);

      //判断扫的是不是发票
      if (isReceipt) return;
      else this.requestOrder();
    },
  },
  created() {
    if (this.$route.query["admin_id"]) {
      this.admin_id = this.$route.query["admin_id"];
      this.getExpressList(this.admin_id);
      console.log('asdsad')
    }

    // this.setScanList(["||SA01|20210400071"]);
  },
  mounted() {
    // this.requestGetExpress();
  },
  methods: {
    onClickInputExpressNo: function (obj, index) {
      this.form = {
        cSysBarCode: obj.cSysBarCode,
        index: index,
        id: obj.id,
        LogisticCode: "",
      };
      this.dialogFormVisible = true;
    },
    onClickGetExpress: async function (obj, index) {
      let expressName = obj.info.cSCName;
      if (expressName == "") {
        this.$message.error("抱歉，没有发货方式，请业务员补充发货发送");
        return;
      }

      let type = this.$tool.expressNameToExpressType(expressName);
      let payType = this.$tool.expressNameToPayType(expressName);


      let expressId = "";
      for (var i = 0; i < this.expressList.length; i++) {
        let express = this.expressList[i];
        if (type == express["abbreviation"] && payType == express["paytype"]) {
          expressId = express["id"];
          // let name =
          //   this.$tool.expressCName(express["abbreviation"]) +
          //   this.$tool.expressPayTypeName(express["paytype"]);
          break;
        }
      }

      if (expressId == "") {
        this.$message.error(
          "抱歉，暂时只支持顺丰、申通、德邦，如要使用其他快递，请联系管理人员"
        );
        return;
      }

      let params = {
        id: obj.id,
        ShipperCode: type,
        store_id: this.admin_id,
        express_id: expressId,
      };
      let result = await this.requestGetExpress(params);

      if (result[0]) {
        var list = [].concat(this.erpDataList);
        list[index].data.rehtml = result[1];
        this.erpDataList = list;

        this.$message({
          message: "快递面单生成成功",
          type: "success",
        });
      } else this.$message.error(result[1]);
    },
    onClickInputExpressConfirm: function () {
      this.requestInputExpress();
    },
    onClickSend: async function (obj, index) {
      let result = await this.requestSendConfirm(obj.cSysBarCode);
      if (result[0]) {
        this.erpDataList.splice(index, 1);
        this.$message({
          message: result[1],
          type: "success",
        });
      } else this.$message.error(result[1]);
    },
    onClickPrint: function (obj) {
      this.$refs.pringContent.setAttribute("srcdoc", obj.rehtml);

      setTimeout(() => {
        var iframe = document.getElementById("print-content");
        // iframe.contentWindow.focus();
        iframe.contentWindow.print();
      }, 1500);
    },
    //获取订单信息
    requestOrder: function () {
      let _this = this;
      let id = this.scanList[this.scanList.length - 1];

      this.$http
        .post("api/get_erp_data", { CallStr: id, admin_id: this.admin_id })
        .then((res) => {
          if (res.data.code == 1001 || res.data.code == 1002) {
            let info = {
              cCusName: "", //客户名称
              SHENGFEN: "", //省
              CHENGSHI: "", //市
              QUXIAN: "", //区
              CADDRESS: "", //地址
              cCusPerson: "", //收件人
              cMobilePhone: "", //收件人手机号
              cSCName: "", //快递方式
              cdepname: "", //部门
              cPsn_Name: "", //业务员
              cWhName: "", //仓库名称
              gs: "", //公司抬头
              cWhName: "", //仓库名称
              cVerifier: "", //发货单审核人
            };

            if (res.data.data.erp_data.length > 0) {
              info.cCusName = res.data.data.erp_data[0].cCusName;
              info.SHENGFEN = res.data.data.erp_data[0].SHENGFEN;
              info.CHENGSHI = res.data.data.erp_data[0].CHENGSHI;
              info.QUXIAN = res.data.data.erp_data[0].QUXIAN;
              info.CADDRESS = res.data.data.erp_data[0].CADDRESS;
              info.cCusPerson = res.data.data.erp_data[0].cCusPerson;
              info.cMobilePhone = res.data.data.erp_data[0].cMobilePhone;
              info.cSCName = res.data.data.erp_data[0].cSCName;
              info.cdepname = res.data.data.erp_data[0].cdepname;
              info.cPsn_Name = res.data.data.erp_data[0].cPsn_Name;
              info.cWhName = res.data.data.erp_data[0].cWhName;
              info.gs = res.data.data.erp_data[0].gs;
              info.cWhName = res.data.data.erp_data[0].cWhName;
              info.cVerifier = res.data.data.erp_data[0].cVerifier;
            }

            if (info.cVerifier == "") {
              _this.$message({
                message: "此发货单未审核，无法进行发货",
                type: "warning",
              });

              return;
            }

            let obj = {
              cSysBarCode: res.data.data.code_id, //ERP的发货单号
              erpData: res.data.data.erp_data,
              info: info,
              outgoing: res.data.data.outgoing, //1 未出库 2 已出库
              id: res.data.data.id,
              data: res.data.data,
              type: 0, //0 出库单 1 发票
            };
            if (res.data.data.outgoing == 1) _this.erpDataList.push(obj);
            else if (res.data.data.outgoing == 2)
              _this.$message({
                message: "此发货单已经出库，请移步订单列表查询",
                type: "warning",
              });
          } else
            _this.$message({
              message: res.data.message,
              type: "warning",
            });
        })
        .catch((err) => {});
    },
    //手填快递单号
    requestInputExpress: function () {
      let _this = this;

      this.$http
        .post("api/update_order_logisticcode", {
          LogisticCode: this.form.LogisticCode,
          order_id: this.form.id,
        })
        .then(async (res) => {
          if (res.data.code == 1001) {
            let result = await _this.requestSendConfirm(_this.form.cSysBarCode);
            if (result[0]) {
              _this.erpDataList.splice(_this.form.index, 1);
              _this.$message({
                message: result[1],
                type: "success",
              });
            }
          } else {
            _this.$message.error(res.data.message);
          }
        })
        .catch((err) => {
          _this.$message.error("服务器出错");
        });
    },
    //确认出库
    requestSendConfirm: function (cSysBarCode) {
      let _this = this;

      return new Promise((resolve) => {
        _this.$http
          .post("api/get_erp_outgoing", { CallStr: cSysBarCode })
          .then((res) => {
            if (res.data.code == 1001) {
              _this.dialogFormVisible = false;
              resolve([true, "发货成功"]);
            } else resolve([false, res.data.message]);
          })
          .catch((err) => {
            resolve([false, "服务器出错"]);
          });
      });
    },
    //申请快递面单
    requestGetExpress: function (params) {
      let _this = this;
      console.log(params);

      return new Promise((resolve) => {
        _this.$http
          .post("api/get_data", params)
          .then((res) => {
            if (res.data.code == 1001) {
              resolve([true, res.data.data.PrintTemplate]);
            } else resolve([false, res.data.message]);
          })
          .catch((err) => {
            resolve([false, "服务器出错"]);
          });
      });
    },
    ...mapActions(["setScanList", "getExpressList"]),
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
  .header {
    padding: 10px;
    color: rgb(0, 0, 0);
    background: linear-gradient(to right, #da3232, #ffffff);
    /* border: 1px solid rgb(110, 110, 110); */
    border-radius: 10px;
    font-size: 30px;
    font-weight: bold;
  }
  .express-list {
    justify-content: space-between;
    margin-top: 10px;
    background-color: #eeeeee;
    border-radius: 10px;
  }
  .item {
    padding: 10px 20px;
    text-align: center;
  }
  .express-title {
    text-align: center;
    color: #000000;
    margin-top: 5px;
    font-size: 13px;
  }
  .one-row-text {
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
  }
</style>



// WEBPACK FOOTER //
// src/components/index.vue